import * as amplitude from '@amplitude/analytics-browser';

/**
 * @desc set userid and email for segment analytics
 */
export const setUser = async (user) => {
  try {
    if (user && user.id) {
      const { id, firstName, lastName, email } = user;
      const analyticsId = `bk-${id}`;
      const userProps = {
        bookkeeperFirstName: firstName,
        bookkeeperLastName: lastName,
        bookkeeperEmail: email
      };
      window.analytics.identify(analyticsId, userProps);

      await amplitude.setUserId(analyticsId);
      const identifyEvent = new amplitude.Identify();
      Object.entries(userProps).forEach(([key, value]) => {
        identifyEvent.set(key, value);
      });
      await amplitude.identify(identifyEvent);
    } else {
      clearUser();
    }
  } catch (e) {
    console.log(e);
  }
};

/**
 * @desc clear user information for segment analytics
 */
const clearUser = () => {
  try {
    console.log('clearUser');
    window.analytics.reset();
    amplitude.reset();
  } catch (e) {
    console.log(e);
  }
};

/**
 * @desc track activity in segment analytics
 */
export const trackActivity = (name, params) => {
  try {
    const newParams = {
      ...params,
      environment: process.env.REACT_APP_ENV
    };

    window.analytics.track(name, newParams);
    amplitude.track(name, newParams);
  } catch (e) {
    console.log(e);
  }
};

export const initAmplitude = () => {
  amplitude.init('212ed2feb2663c8004ae16498974992b', {
    serverUrl: 'https://analytics-proxy.keepertax.com/amplitude/2/httpapi',
    autocapture: {
      pageViews: false,
      attribution: false
    }
  });
};
